export const SYNC_CONFIGURATION_PAGE_CONTENT = `### Overview

This page presents the Device Management microfrontend features consumed by Client Portal for synchronizing device configurations.

In Client Portal, you can find these features in the following locations:

- **Store:** Open Store details and select the option from the kebab menu in the upper-right corner.
- **Merchant:** Open Merchant details and select the option from the kebab menu in the upper-right corner.
- **Devices:**
  - Open device details and select the option from the kebab menu in the upper-right corner to synchronize a single device.
  - In the Virtual devices list, select one or more devices to access the synchronization option.`;
